import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  EventEmitter,
  inject,
  OnInit,
  Output,
} from '@angular/core';
import { ControlContainer, ReactiveFormsModule } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ImmomioIconName } from '@resident-nx/shared';
import { debounceTime, filter } from 'rxjs';
import { TicketCreationService } from '../../../../../services';
import { TicketsNoCatalogueComponent } from '../tickets-no-catalogue/tickets-no-catalogue.component';
import { LoaderWebComponent, IconWebComponent } from '@resident-nx/web/ui';

@Component({
  standalone: true,
  selector: 'rs-web-ticket-categories',
  templateUrl: './ticket-categories.component.html',
  styleUrl: './ticket-categories.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [
    {
      provide: ControlContainer,
      useFactory: () => inject(ControlContainer, { skipSelf: true }),
    },
  ],
  imports: [
    ReactiveFormsModule,
    IconWebComponent,
    AsyncPipe,
    LoaderWebComponent,
    TicketsNoCatalogueComponent,
  ],
})
export class TicketCategoriesComponent implements OnInit {
  #ticketCreationService = inject(TicketCreationService);
  #destroyRef = inject(DestroyRef);
  public categoriesFormRecord = this.#ticketCreationService.categoriesFormRecord;
  public currentCategoryFormControl = this.#ticketCreationService.currentCategoryFormControl;
  public categoriesActionState = this.#ticketCreationService.categoriesActionState;
  public step = this.#ticketCreationService.categoryStep;
  @Output() categoryQuestionChange = new EventEmitter<void>();

  ngOnInit() {
    this.#ticketCreationService.fetchCategoryQuestions();
    this.categoriesFormRecord.valueChanges
      .pipe(
        filter(v => !Object.values(v).some(value => value === null)),
        debounceTime(100),
        takeUntilDestroyed(this.#destroyRef)
      )
      .subscribe(value => {
        const latestValue = value[this.currentCategoryFormControl.value.id];
        if (latestValue.questionIds.length) {
          this.#ticketCreationService.setCurrentCategoryAndRecord(latestValue.questionIds[0]);
        } else {
          this.categoryQuestionChange.emit();
        }
      });
  }

  public goToPreviousCategory() {
    this.#ticketCreationService.goToPreviousCategory();
    this.categoryQuestionChange.emit();
  }

  protected readonly ImmomioIcons = ImmomioIconName;
}
